import './EllipsisSpinner.css'
export function EllipsisSpinner() {
    return (
        <div className='flex flex-row justify-center'>
            <div className="lds-ellipsis"><div></div><div></div><div></div><div></div></div>
        </div>
    )
}